import { apiClient as axios } from '@auto-cargo/protocol-sdk';

// Re-export shared auth types from protocol-sdk
export type { CaptchaResult, LoginData, LoginResult } from '@auto-cargo/protocol-sdk';

/**
 * Types (admin-specific wrappers)
 */
import type { ResType } from '@repo/typings/common';
import type { Role } from '@repo/typings/role';
import type { User } from '@repo/typings/user';

// Admin-specific login result with full Role/User types
export type AdminLoginResult = {
    permissions: string[];
    roles: Role[];
    token: string;
    user: User;
};

/**
 * Auth APIs - delegate to shared endpoints
 * Uses apiClient (raw axios) to preserve AxiosResponse wrapping for ahooks/useRequest
 */
export const captcha = () => {
    return axios<ResType<{ captcha: string; key: string }>>('/v1/auth/verifycode', {
        method: 'get',
    });
};

export const login = (data: { username: string; password: string; captcha: string; key: string }) => {
    return axios<ResType<AdminLoginResult>>('/v1/auth/login', {
        data,
        method: 'post',
    });
};

export const logout = () => {
    return axios<ResType<Omit<AdminLoginResult, 'token' | 'user'> & User>>('/v1/auth/logout', {
        method: 'post',
    });
};

export const me = () => {
    return axios<ResType<Omit<AdminLoginResult, 'token' | 'user'> & User>>('/v1/me', {
        method: 'get',
    });
};
